import { render, staticRenderFns } from "./Derived.vue?vue&type=template&id=aaa45f0a&scoped=true"
import script from "./Derived.vue?vue&type=script&lang=js"
export * from "./Derived.vue?vue&type=script&lang=js"
import style0 from "./Derived.vue?vue&type=style&index=0&id=aaa45f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa45f0a",
  null
  
)

export default component.exports